import { put, call, takeEvery } from 'typed-redux-saga';

import GoldGateway from '~apis/gold';
import combinedActions from '~redux/combinedActions';
import { store } from '~redux/store';

import { GatewayResponseStatus } from '~types/gateway';
import { SagaWatcherReturnType } from '~types/saga';

import { ErrorMessages } from '~utils/constants';
import { GoldSilverTypeEnum, GoldTypeEnum, MetalTypeEnum, SilverTypeEnum, TransactionActionEnum, TransactionStatusEnum } from '~utils/enums';
import UtilFunctions from '~utils/functions';

export default function* watchGetTransactionListing(api: GoldGateway): SagaWatcherReturnType {
    yield takeEvery('gold/goldGetTransactionListingAttempt', handleGetTransactionListing, api);
}

function* handleGetTransactionListing(api: GoldGateway) {
    const reduxState = store.getState();
    const authToken = reduxState.auth.userDetails.authToken;
    const {
        index,
        filters: {
            action,
            status,
            name,
            idNo,
            dateFrom,
            dateTo,
            branchName,
            metalType,
            goldType,
            silverType,
        },
    } = reduxState.gold.buyAndSellGold.transactionListing;

    const allBranches = reduxState.branch.allBranches;

    const branchCode = allBranches.find(branch => branch.branchName === branchName)?.branchCode;

    if (!index && index !== 0) {
        yield put(combinedActions.goldGetTransactionListingFailure(ErrorMessages.GenericRequiredFieldNotFilledIn));
        return;
    }

    const response = yield* call([api, api.getTransactionListing], {
        authToken,
        index,
        action: action ? UtilFunctions.Misc.getEnumValueByKey(TransactionActionEnum, action) : undefined,
        status: status ? UtilFunctions.Misc.getEnumValueByKey(TransactionStatusEnum, status) : undefined,
        name: name ? name : undefined,
        idNo: idNo ? idNo : undefined,
        dateFrom: dateFrom ? dateFrom : undefined,
        dateTo: dateTo ? dateTo : undefined,
        branchCode: branchCode ? branchCode : undefined,
        metalType: metalType ? UtilFunctions.Misc.getEnumValueByKey(MetalTypeEnum, metalType.split(' ').join('')) : undefined,
        goldType: goldType ? UtilFunctions.Misc.getEnumValueByKey(GoldSilverTypeEnum, goldType.split(' ').join('')) : undefined,
        silverType: silverType ? UtilFunctions.Misc.getEnumValueByKey(GoldSilverTypeEnum, silverType.split(' ').join('')) : undefined,
    });

    if (response.status === GatewayResponseStatus.Error) {
        yield put(combinedActions.goldGetTransactionListingFailure(response.message || ErrorMessages.GenericError));
        return;
    }

    if (response.status === GatewayResponseStatus.Success) {
        yield put(combinedActions.goldGetTransactionListingSuccess(response.data));
    }
}
